import { lazy, Suspense } from 'react';

import { LoadingScreen } from 'src/components/loading-screen';
import { PrototypeShell } from 'src/_design/shell/PrototypeShell';
import { AuthPrototypeShell } from 'src/_design/shell/AuthPrototypeShell';
import { BarePrototypeShell } from 'src/_design/shell/BarePrototypeShell';

// ----------------------------------------------------------------------
// Dev-only design sandbox. Mounted at /_design ONLY when Development is on
// (see routes/sections/index.tsx). Lives OUTSIDE the AuthGuard so prototypes
// render without a login — which lets headless-Chrome screenshots work.
// ----------------------------------------------------------------------

const PrototypeIndex = lazy(() => import('src/_design/PrototypeIndex'));
const Gallery = lazy(() => import('src/_design/gallery/Gallery'));
const PrototypeHost = lazy(() => import('src/_design/PrototypeHost'));

const wrap = (node: React.ReactNode) => <Suspense fallback={<LoadingScreen />}>{node}</Suspense>;

export const designRoutes = [
  {
    path: '/_design',
    element: <PrototypeShell />,
    children: [
      { index: true, element: wrap(<PrototypeIndex />) },
      { path: 'gallery', element: wrap(<Gallery />) },
      { path: 'p/:slug', element: wrap(<PrototypeHost />) },
    ],
  },
  {
    // Auth-flow prototypes (invite/register/login/reset screens) render in the
    // real AuthLayout instead of the dashboard-chrome PrototypeShell — see
    // src/_design/shell/AuthPrototypeShell.tsx.
    path: '/_design/auth',
    element: <AuthPrototypeShell />,
    children: [{ path: ':slug', element: wrap(<PrototypeHost />) }],
  },
  {
    // Full-page takeover prototypes (offline, maintenance, session-expired)
    // render with no sandbox chrome at all — see BarePrototypeShell.tsx.
    path: '/_design/bare',
    element: <BarePrototypeShell />,
    children: [{ path: ':slug', element: wrap(<PrototypeHost />) }],
  },
];
